// extracted by mini-css-extract-plugin
module.exports = {"bfEditor":"CourseData_bfEditor__39kja"};